export const appName = "XzisTech.com";
export const linkedin = "https://www.linkedin.com/company/xzistech";
export const instagram = "https://www.instagram.com/xzistech?igsh=eTg0djJoZTFxd2Zp";
export const twitter = "https://twitter.com/xzistech";
export const facebook = "https://www.facebook.com/profile.php?id=61558011313247";
const phoneNumber="+918527795500";
const message = "Hi, I wanted to know about web development services";
export const whatsapp= `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;